import { UIElementType } from '@ply-io/ply-front-shared-utilities';

export const DEFAULT_TEXT = {
	color: '#000000',
	fontSize: 14,
	value: '',
};

export const DEFAULT_DROPDOWN = {
	value: '',
};

export const DEFAULT_ICON = {
	size: 14,
	fillColor: '#F97F7F',
	name: 'ply-element-default-icon',
	local: true,
};

export const DEFAULT_TOOLTIP = {
	value: '',
};

export const DEFAULT_INJECTION_STYLE = {
	backgroundColor: 'transparent',
	width: 25,
	borderRadius: 0,
	borderColor: '#00000000',
	text: {
		...DEFAULT_TEXT,
	},
	dropdownText: {
		...DEFAULT_DROPDOWN,
	},
	icon: {
		...DEFAULT_ICON,
	},
	tooltipText: {
		...DEFAULT_TOOLTIP,
	},
};

export const DEFAULT_ELEMENT_METADATA = {
	text: 'Text',
	injectionStyle: {
		...DEFAULT_INJECTION_STYLE,
	},
};

export const DEFAULT_PLY_ELEMENT_OBJECT = {
	id: 1,
	type: UIElementType.Button,
	name: '', // todo, this should be placeholder?
	metadata: {
		...DEFAULT_ELEMENT_METADATA,
	},
};
